// ##### 26-07-30 Komarov
import axios from 'axios';

const IS_BROWSER =
  typeof window === 'object' &&
  '[object Window]' === window.toString.call(window);

export const smartApiPost = async (url, data) => {
  if (IS_BROWSER) {
    return axios.post(`${process.env.REACT_APP_URL}api/smart-proxy`, {
      url,
      method: 'POST',
      data,
    });
  }
  return axios.post(url, data);
};

export const smartApiGet = async url => {
  if (IS_BROWSER) {
    return axios.post(`${process.env.REACT_APP_URL}api/smart-proxy`, {
      url,
      method: 'GET',
    });
  }
  return axios.get(url);
};
